module.exports = __webpack_public_path__ + "static/img/basicnew1.a098bb5e.png";